/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Block_SpecsInputs */

const cs_builder_block_specs = /** @type {(inputs: Builder_Block_SpecsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parametry`)
};

const en_builder_block_specs = /** @type {(inputs: Builder_Block_SpecsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specs list`)
};

/**
* | output |
* | --- |
* | "Specs list" |
*
* @param {Builder_Block_SpecsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_block_specs = /** @type {((inputs?: Builder_Block_SpecsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Block_SpecsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_block_specs(inputs)
	return cs_builder_block_specs(inputs)
});